import {createSelector} from 'reselect'

export const getShowNavigation = createSelector(
  state => state && state.vehicleParts && state.vehicleParts.list && state.vehicleParts.list.showNavigation,
  showNavigation => showNavigation
)
